var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noDisc"},[_c('div',[_c('img',{attrs:{"src":require("../..//assets/img/ukey404.png")}})]),_c('div',[_c('p',[_vm._v("尚未插入税盘")]),_c('p',[_vm._v("尚未插入税盘，请插入税盘后重试")])])])
}]

export { render, staticRenderFns }